<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="单号：" prop="code">
                <span>{{model.code}}</span>
            </el-form-item>
            <el-form-item label="重量：" prop="weight">
                <span>{{model.weight}}</span>
            </el-form-item>
            <el-form-item label="时间：" prop="add_time">
                <span>{{model.add_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'weightDataInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                code: '',
                weight: '',
                add_time: '',
            },
            getObj:{
                url:'/api/admin/weightdata/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>